import { h, Component } from 'preact';
import cn from 'classnames';
import { Link } from 'preact-router';
import Content from '../content/content';
import styles from './footer.css';

export default class Footer extends Component {
  render() {
    const { className } = this.props;
    return (<footer className={cn(className, styles.container)}>
      <Content>
        <div className="flex">
          <nav className={styles.nav}>
            <span className={cn(styles.copyright, 'flex-grow')}>&copy; Trouble Brewing {new Date().getFullYear()}</span>
            <Link className={styles.navItem} href="/privacy">Privacy Policy</Link>
            <Link className={styles.navItem} href="/terms">Ts &amp; Cs</Link>
            <span className={`${styles.menuItem} ${styles.sociaspantem}`}>
              <a href="https://www.facebook.com/TroubleBrewingSingapore/" target="_blank" rel="noopener noreferrer"><img className={styles.social} src="/assets/facebookCircle.png" /></a>
            </span>
            <span className={`${styles.menuItem} ${styles.socialItem}`}>
              <a href="https://www.instagram.com/troublebrewingsg/" target="_blank" rel="noopener noreferrer"><img className={styles.social} src="/assets/instagramCircle.png" /></a>
            </span>
          </nav>
        </div>
      </Content>
    </footer>);
  }
}



// WEBPACK FOOTER //
// ./components/footer/footer.jsx